import { colors } from '@lmc/common/constants'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import React from 'react'
import { ProfileField } from '../../../../../../components/generic'
import ResidentProfileSectionWrapper from './ResidentProfileSectionWrapper'

export default function ResidentProfileCareRelated({ profile, features }) {
  if (!features.carePlans && !features.eMAR) return null
  return (
    <ResidentProfileSectionWrapper
      color={colors.purple}
      icon="health-visit"
      style={styles.wrapper}
      title="Care related information"
    >
      <div className="lmc-card" style={styles.contentContainer}>
        <ProfileField
          label="Allergies"
          style={styles.field}
          value={getValue('allergies', profile)}
        />
        {features.carePlans &&
          CARE_RELATED_FIELDS.map((field, i) => {
            const isCanada = features.countryCode === 'CA'
            const label =
              isCanada && field.key === 'nhsNumber'
                ? field.altLabel
                : field.label
            if (isCanada && field.key === 'nationalInsurance') {
              return null
            }
            return (
              <ProfileField
                key={i}
                label={label}
                style={styles.field}
                value={getValue(field.key, profile, isCanada)}
              />
            )
          })}
        {features.eMAR &&
          EMAR_ADMIN_FIELDS.map((field, i) => (
            <ProfileField
              key={i}
              label={field.label}
              style={styles.field}
              value={getValue(field.key, profile)}
            />
          ))}
      </div>
    </ResidentProfileSectionWrapper>
  )
}

const getValue = (key, profile, isCanada) => {
  let value = profile[key]

  // hasAllergies === Yes or None known
  if (key === 'allergies' && profile.hasAllergies === 'None known') {
    value = profile.hasAllergies
  }

  if (!value) {
    return <span style={styles.noInfo}>No information entered</span>
  }
  switch (key) {
    case 'admissionDate':
      return dayjs(value).format('Do MMMM YYYY')
    case 'nationalInsurance':
      // formats NI number with spaces
      return value.match(/.{1,2}/g).join(' ')
    case 'nhsNumber':
      // formats NHS number as string with spaces
      value = value.toString()
      if (isCanada) {
        return `${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(
          6,
          9
        )} ${value.slice(9, 12)}`
      }
      return `${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6)}`
    default:
      return value
  }
}

const CARE_RELATED_FIELDS = [
  {
    key: 'bloodType',
    label: 'Blood Type'
  },
  {
    key: 'medicalHistory',
    label: 'Medical History'
  },
  {
    key: 'admissionDate',
    label: 'Admission date'
  },
  {
    key: 'nationalInsurance',
    label: 'National Insurance number'
  },
  {
    key: 'nhsNumber',
    label: 'NHS number',
    altLabel: 'Health Care Number'
  },
  {
    key: 'fundingSource',
    label: 'Funding source'
  },
  {
    key: 'fundingSourceOther',
    label: 'Other funding source'
  },
  {
    key: 'height',
    label: 'Height (cm)'
  }
]

const EMAR_ADMIN_FIELDS = [
  {
    key: 'preferredAdminRoute',
    label: 'Tablets in hand/pot/mouth'
  },
  {
    key: 'preferredDrink',
    label: 'Preferred drink'
  },
  {
    key: 'prnMedsNote',
    label: 'PRN Meds'
  }
]

const styles = {
  field: {
    textAlign: 'left'
  },
  noInfo: {
    color: colors.black
  },
  wrapper: {
    marginTop: 60
  }
}

ResidentProfileCareRelated.propTypes = {
  profile: PropTypes.object.isRequired
}
